// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".data-scroll-sticky{position:absolute;width:100%;@media (max-width:1023px){margin-top:115px}}", ""]);
// Exports
module.exports = exports;
